export default {
  blocking: (x) => `${x * 40}px`,
  image: '120px',
  card: '600px',
};
